export class AuthenticationError extends Error {
    readonly kind = 'AuthenticationError';
    constructor() {
        super('AuthenticationError');
    }
}
